<qe-sidebar-infocard
	class="policy-breakdown"
	headingBackground="primary"
>
	<epi-heading
		level="3"
		color="light"
	>
		My Policy
	</epi-heading>
	<ng-container *ngFor="let pet of pets$ | async">
		<qe-pet-policy-breakdown
			class="policy-breakdown__pet"
			[attr.pet-age]="pet.ageInYears"
			[showItemizedInfo]="showItemizedInfo"
			[showAddPetButton]="showAddPetButton"
			[showFullPetInfo]="showFullPetInfo"
			[showEditButtons]="showEditButtons"
			[showPetInfoToggle]="showPetInfoToggle"
			[pet]="pet"
		></qe-pet-policy-breakdown>
	</ng-container>
	<section
		*ngIf="showItemizedInfo"
		class="policy-breakdown__pricing u-margin-top-small"
	>
		<epi-infoline
			layout="loose"
			data-quat="value_policyPremium"
		>
			<span slot="key">Insurance:</span>
			<span slot="value">{{ (quoteDetails$ | async)?.insurancePremiums | currency }}</span>
		</epi-infoline>
		<epi-infoline
			*ngIf="(quoteDetails$ | async)?.totalDiscounts"
			layout="loose"
			data-quat="value_policyDiscounts"
		>
			<span class="discount-label" slot="key">Discounts
				<div class="discount-tooltip">
					<svg
						class="discount-tooltip__trigger"
						(mouseenter)="onTooltipEnter()"
						(mouseleave)="onTooltipLeave()"
					>
						<use href="../../../assets/icons/info-mark-outline.svg#info-white"></use>
					</svg>
					<div
						class="discount-tooltip__container"
						*ngIf="isTooltipHovered"
					>
						<p class="discount-tooltip__content">We have a maximum discount of 25% for any pet.</p>
					</div>
				</div>
			</span>
			<span slot="value">- {{ (quoteDetails$ | async)?.totalDiscounts | currency }}</span>
		</epi-infoline>
		
		<epi-infoline
			*ngIf="(quoteDetails$ | async)?.totalWellness"
			layout="loose"
			data-quat="value_policyWellness"
		>
			<span slot="key">Wellness:</span>
			<span slot="value">{{ (quoteDetails$ | async)?.totalWellness | currency }}</span>
		</epi-infoline>
		<epi-infoline
			*ngIf="(quoteDetails$ | async)?.stateTaxes"
			layout="loose"
			data-quat="value_policyStateSurcharge"
		>
			<span slot="key">
				State Surcharge:&nbsp;
				<!--
					FIXME:
						- Add color to the component definition instead of allowing it to inherit
						- fix tooltip positioning
				-->
				<epi-tooltip
					style="color: var(--richBlack);"
					icon-color="accent"
				>
					Your premium includes a state surcharge, as required by law
				</epi-tooltip>
			</span>
			<span slot="value">{{ (quoteDetails$ | async)?.stateTaxes | currency }}</span>
		</epi-infoline>
		<epi-infoline
			layout="loose"
			data-quat="value_policyBillingFee"
		>
			<span slot="key">Installment fee:</span>
			<span slot="value">{{ (quoteDetails$ | async)?.billingFee | currency }}</span>
		</epi-infoline>
		<epi-infoline
			layout="loose"
			break="both"
			match-break-color="true"
			make-bold="key value"
			data-quat="value_policyMonthlyPremium"
		>
			<span slot="key">Total per {{ getFrequencyViewValue((quoteDetails$ | async)?.paymentModality) }}:</span>
			<span slot="value">{{ (quoteDetails$ | async)?.monthlyPremium | currency }}</span>
		</epi-infoline>
		<epi-infoline
			*ngIf="(quoteDetails$ | async)?.oneTimeEnrollmentFee"
			layout="loose"
			data-quat="value_policyEnrollmentFee"
		>
			<span slot="key">One-time admin fee:</span>
			<span slot="value">{{ (quoteDetails$ | async)?.oneTimeEnrollmentFee | currency }}</span>
		</epi-infoline>
		<epi-infoline
			layout="loose"
			make-bold="key value"
			data-quat="value_totalBilledMonthly"
		>
			<span slot="key">Total billed today:
				<!-- TODO: Replace if statement below when New Hampshire fee work completed (feature #23890) -->
				<!-- *ngIf="displayFeeTooltip$ | async" -->
				<epi-tooltip
					*ngIf="false"
					style="color: var(--richBlack);"
					icon-color="accent"
				>
					The total billed today includes your first month of premium and a one-time admin fee. You won’t be
					charged a monthly installment fee on your first payment.
				</epi-tooltip>
			</span>
			<span slot="value">{{ (quoteDetails$ | async)?.dueToday | currency }}</span>
		</epi-infoline>
	</section>
	<section
		*ngIf="showAddPetButton"
		class="policy-breakdown__add-pet"
	>
		<epi-button
			button-type="minimal"
			color="secondary"
			(click)="addNewPet()"
			data-quat="action_policyAddPet"
		>
			<epi-icon
				use="solid-plus-mark"
				[size]="16"
				color="secondary"
				class="policy-breakdown__add-pet-icon"
			></epi-icon>
			Add a Pet
		</epi-button>
	</section>
</qe-sidebar-infocard>